
function Loader() {
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: "20px" }}>
      <img
        src="assets/images/loading.gif"
        alt="Loading..."
        width="15%"
        align="center"
      />
    </div>
  );
}

export default Loader;